import { render, staticRenderFns } from "./PlannedFurnitureSection.vue?vue&type=template&id=319de1a6&scoped=true&"
import script from "./PlannedFurnitureSection.vue?vue&type=script&lang=js&"
export * from "./PlannedFurnitureSection.vue?vue&type=script&lang=js&"
import style0 from "./PlannedFurnitureSection.vue?vue&type=style&index=0&id=319de1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319de1a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
